import { useEffect, useLayoutEffect } from 'react'
import i18next from 'i18next'
import { useDispatch, useSelector } from 'react-redux'
import AuthExperienceSelectors from '../../../redux/selectors/experiences/Auth'
import useNormalizedLanguages from '../../../redux/hooks/useNormalizedLanguages'
import ProfileService from '../../../services/Profile'
import AuthExperienceActions from '../../../redux/actions/experiences/Auth'
import { resolveLanguageIdFromI18NCode } from '../languageMapping'
import { applyProfileLanguage, isApplyingProfileLanguage } from '../applyProfileLanguage'

const ProfileLanguageSync = () => {
  const dispatch = useDispatch()
  const profile = useSelector(AuthExperienceSelectors.profile)
  const isAuthenticated = useSelector(AuthExperienceSelectors.isAuthenticated)
  const languagesById = useNormalizedLanguages(null, true) || {}

  // Apply profile language whenever profile or language catalog is ready (login, save, refresh).
  useLayoutEffect(
    () => {
      if (!isAuthenticated || !profile?.languageId) {
        return
      }

      applyProfileLanguage({
        languageId: profile.languageId,
        languagesById
      })
    },
    [isAuthenticated, profile?.languageId, languagesById]
  )

  // When UI language changes outside profile save: persist to API.
  useEffect(
    () => {
      if (!isAuthenticated) {
        return undefined
      }

      const handleLanguageChanged = async (nextCode) => {
        if (isApplyingProfileLanguage()) {
          return
        }

        const languageId = resolveLanguageIdFromI18NCode(languagesById, nextCode)
        if (!languageId || Number(profile?.languageId) === languageId) {
          return
        }

        try {
          const result = await ProfileService.Update({ languageId: Number(languageId) })
          if (result.status === 200 && profile) {
            dispatch(
              AuthExperienceActions.setProfile({
                ...profile,
                languageId: Number(languageId)
              })
            )
          }
        } catch {
          // Non-blocking: UI language still changed locally
        }
      }

      i18next.on('languageChanged', handleLanguageChanged)
      return () => {
        i18next.off('languageChanged', handleLanguageChanged)
      }
    },
    [dispatch, isAuthenticated, languagesById, profile]
  )

  return null
}

export default ProfileLanguageSync
